var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},_vm._l((_vm.investments),function(investment,key){return _c('div',{key:key,staticClass:"col-12 col-sm-6 col-md-5"},[_c('investment-card',{attrs:{"investment":investment}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }